/**
 * 权限/角色相关 API
 */
import { request } from './request'

/**
 * 获取所有角色列表
 * @returns {Promise<{ success, data: Array<{ role_id, role_name, role_description, ... }>, count }>}
 */
export function getRoles(options = {}) {
  return request('/api/roles', options)
}

/**
 * 根据 ID 获取角色
 */
export function getRoleById(id) {
  return request(`/api/roles/${id}`, {})
}

/**
 * 创建角色
 * @param {{ role_name, role_description, create_by }} data
 */
export function createRole(data) {
  return request('/api/roles', {
    method: 'POST',
    body: JSON.stringify(data)
  })
}

/**
 * 更新角色
 * @param {number} id - 角色 ID
 * @param {{ role_name?, role_description?, update_by? }} data
 */
export function updateRole(id, data) {
  return request(`/api/roles/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data)
  })
}

/**
 * 删除角色
 */
export function deleteRole(id) {
  return request(`/api/roles/${id}`, { method: 'DELETE' })
}
